/**
 * <s-sticky-buy> — mobile add-to-cart bar for the product page.
 * Shows itself once the main add-to-cart area ([data-main-add]) has scrolled above the viewport,
 * and hides again while the main button or the site footer is on screen.
 * The bar lives inside the product form, so its submit button uses the same add-to-cart flow.
 * The variant picker re-renders the form partial; each new instance re-observes on connect.
 */
class SStickyBuy extends HTMLElement {
  connectedCallback() {
    this.mainAdd = this.closest('form')?.querySelector('[data-main-add]');
    this.footer = document.querySelector('footer');
    if (!this.mainAdd || !('IntersectionObserver' in window)) return;

    this.mainPassed = false;
    this.footerVisible = false;

    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this.mainAdd) {
          this.mainPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        } else if (entry.target === this.footer) {
          this.footerVisible = entry.isIntersecting;
        }
      }
      this.toggle(this.mainPassed && !this.footerVisible);
    });

    this.observer.observe(this.mainAdd);
    if (this.footer) this.observer.observe(this.footer);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  toggle(show) {
    this.toggleAttribute('data-visible', show);
    this.inert = !show;
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
